import {
  GET_PARTICIPANTS_LIST,
  ADD_PARTICIPANT,
  REMOVE_PARTICIPANT,
  HAND_RAISED,
  CHANGE_SUBSCRIBER_ROLE,
  HAND_UNRAISED,
} from './participantsListAction';

const initialState = {
  participantsList: [],
  subscriberData: {},
};

const participantsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTICIPANTS_LIST:
      return {
        ...state,
        participantsList: action.payload,
      };
    case ADD_PARTICIPANT:
      if (action.payload) {
        return {
          ...state,
          participantsList: [...state.participantsList, action.payload],
        };
      }
      break;
    case REMOVE_PARTICIPANT:
      if (action.payload) {
        return {
          ...state,
          participantsList: state.participantsList.filter(
            (item) =>
              item.vonageParticipantId !== action.payload.vonageParticipantId
          ),
        };
      }
      break;
    case HAND_RAISED:
      if (action.payload) {
        return {
          ...state,
          participantsList: state.participantsList.map((item) => {
            if (
              item.vonageParticipantId === action.payload.vonageParticipantId
            ) {
              return { ...item, handRaised: true };
            } else {
              return item;
            }
          }),
        };
      }
      break;
    case HAND_UNRAISED:
      if (action.payload) {
        return {
          ...state,
          participantsList: state.participantsList.map((item) => {
            if (
              item.vonageParticipantId === action.payload.vonageParticipantId
            ) {
              return { ...item, handRaised: false };
            } else {
              return item;
            }
          }),
        };
      }
      break;
    case CHANGE_SUBSCRIBER_ROLE:
      return {
        ...state,
        subscriberData: action.payload,
      };
    default:
      return state;
  }
};
export default participantsListReducer;
